import { css } from '@emotion/css'
import { fontSize, fontWeight, colors, spacing, mediaQueryHelper, breakpoint } from '@offerzen/pinata-shame'

const termsContainerWidth = 640

const styles = {
  container: css({
    maxWidth: termsContainerWidth,
    margin: 'auto',
    left: 0,
    right: 0,
    textAlign: 'center',
    paddingTop: spacing.extraLarge,

    p: {
      marginBottom: 0,
      color: colors.blackPearl,
    },

    [mediaQueryHelper(breakpoint.tablet, 'max-width')]: {
      paddingLeft: spacing.default,
      paddingRight: spacing.default,
    },
  }),

  termsHeading: css({
    fontSize: fontSize.large,
    fontWeight: fontWeight.bold,
    marginTop: spacing.medium,
  }),
}

export default styles
